import script from "./DataMapperDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataMapperDialog.vue?vue&type=script&setup=true&lang=ts"

import "./DataMapperDialog.vue?vue&type=style&index=0&id=3b82bfd9&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b82bfd9"]])

export default __exports__